import Estimate from "@/orders/domain/models/estimate";
import EstimateItem from "@/orders/domain/models/estimate-item";
import EstimateItems from "@/orders/domain/models/estimate-items";
import UnitPrice from "@/orders/domain/models/unit-price";
export function toEstimate(data: any): Estimate {
  return new Estimate(
    data.id,
    data.estimateNumber,
    data.title,
    data.attention,
    data.mention,
    data.projectId,
    data.projectName,
    data.staffName,
    data.projectClientName,
    data.status,
    toEstimateItems(data.items, data.categoryDiscountIds),
    data.taxRate,
    Boolean(data.printsExcludeTax),
    data.dateOfIssue,
    data.dateOfContract,
    data.deadline,
    data.profitRate,
    data.children.map((child: any) => {
      child.categoryDiscountIds = data.categoryDiscountIds;
      return toEstimate(child);
    }),
    data.taskDefaults,
    data.categoryDiscountIds
  );
}

export function toEstimateItems(
  data: any[],
  idsDiscount: any[]
): EstimateItems {
  if (data.length > 0) {
    return new EstimateItems(
      ...data.map(element => toEstimateItem(element, idsDiscount))
    );
  }
  return new EstimateItems();
}

export function toEstimateItem(data: any, idsDiscount: any[]): EstimateItem {
  let unitPrice = isNaN(data.unitPrice) ? 0 : data.unitPrice;
  unitPrice =
    idsDiscount &&
    idsDiscount.includes(data.expenseCategoryId) &&
    unitPrice != 0
      ? -Math.abs(unitPrice)
      : unitPrice;

  return new EstimateItem(
    data.id,
    data.unitName,
    data.unitType,
    new UnitPrice(unitPrice),
    new UnitPrice(data.unitLoss),
    data.amount,
    Number(data.totalPrice),
    data.memo,
    Boolean(data.purchased),
    Boolean(data.purchasedRow),
    data.items.length > 0 ? "" : data.expenseCategoryId,
    toEstimateItems(data.items, idsDiscount),
    data.vendorName,
    data.isEditable,
    data.tempUuid,
    data.level,
    data.isFromActualResult
  );
}
